export const menCategories=[
    {name:"Category",subitems:["Shirts","Hoodies","Pants"]},
    // {name:"watch shape",subitems:["round"]},
    // {name:"movement",subitems:["self-winding","manual-winding","quartz"]},
    // {name:"type of strap",subitems:["interchargeable","leather","metal"]},
]

export const womenCategories=[
    {name:"Category",subitems:["Shirts","Hoodies","Pants","Bags"]},
    // {name:"watch shape",subitems:["round"]},
    // {name:"movement",subitems:["self-winding","manual-winding","quartz"]},
    // {name:"type of strap",subitems:["interchargeable","leather","metal"]},
]